/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type ForcJournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import type SemeiaSessionService from "parog-web/services/session";
import Sections from "./sections";

interface Signature {
  Args: {
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default class MiciBaseConsultForm extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  Sections = Sections;

  get shouldShowScore(): boolean {
    return Boolean(this.session.medic);
  }
}
